import AppointmentCalendar from '../appointmentCalendar/AppointmentCalendar';
import FormTextArea from '../../../common/components/formElements/FormTextArea';
import useSelectAppointmentDate from '../../hooks/useSelectAppointmentDate';
import ErrorModal from '../../../common/components/customRedAlert/CustomRedAlert';
import PhoneInput from 'react-phone-input-2';
import { useEffect, useState } from 'react';
import create from 'zustand';
import { DoctorProfile } from '../../../v2/services/DoctorProfile';
import { useParams, useNavigate } from 'react-router-dom';
import FormInputField from '../../../common/components/formElements/FormInputField';
import { Appointment } from '../../../../src/v2/services/Appointment';
import { MailIcon } from '@heroicons/react/outline';
import useAppointmentStore from '../../../common/state/useAppointmentStore';
export const docStore = create((set) => ({
    docData: null,
    setDocData: (data) => set({ docData: data })
}));

export default function CalendarAppointmentDateSelectionElement() {
    const navigate = useNavigate();
    const { docData, setDocData } = docStore((state) => state);
    const { setDoctorData, setSelectedAppointment: setStoreSelectedAppointment } = useAppointmentStore(
        (state) => state
    );
    const [isLoading, setLoading] = useState(true);
    const { doctorId, doctorName } = useParams();
    const [motiveId, setMotiveId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [apiError, setApiError] = useState('');
    const {
        availableAppointments,
        setSelectedAppointment,
        selectedAppointment,
        queryAppointmentHistory,
        additionalInfo,
        onSetAdditionalInfo,
        onCreateDoctorAppointment,
        onCloseErrorModal,
        error
    } = useSelectAppointmentDate({ doctorData: docData });

    const [formData, setFormData] = useState({
        appointmentDate: '',
        doctorNotes: '',
        idAppointmentMotive: '',
        idAvailability: '',
        idDoctor: doctorId,
        patientEmail: '',
        patientFirstName: '',
        patientLastName: '',
        patientPhone: '',
        countryCode: '+503'
    });

    useEffect(() => {
        setLoading(true);
        DoctorProfile.getOwnProfile(doctorId)
            .then((res) => setDocData(res.data))
            .then(() => setLoading(false));
    }, []);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            idAppointmentMotive: motiveId || '',
            appointmentDate: selectedAppointment?.date || '',
            idAvailability: selectedAppointment?.id || ''
        }));
    }, [motiveId, selectedAppointment]);
    // if(!setSelectedAppointment){
    //     return <Loader />
    // }
    const handleFormCreate = async (e) => {
        e.preventDefault();

        const errors = {};
        if (!formData.idAppointmentMotive) errors.idAppointmentMotive = 'Seleccione un motivo de consulta.';
        if (!formData.patientFirstName.trim()) errors.patientFirstName = 'Nombre de pila es requerido.';
        if (!formData.patientLastName.trim()) errors.patientLastName = 'Apellido es requerido.';
        if (!formData.patientEmail.trim()) errors.patientEmail = 'Correo electrónico es requerido.';
        if (!formData.patientPhone.trim()) errors.patientPhone = 'Teléfono es requerido.';
        if (!formData.countryCode.trim()) errors.countryCode = 'Código de país es requerido.';
        if (!formData.doctorNotes.trim()) errors.doctorNotes = 'Descripción es requerida.';
        if (!motiveId) errors.idAppointmentMotive = 'Seleccione un motivo de consulta.';
        if (!selectedAppointment) errors.appointmentDate = 'Seleccione una fecha de cita.';

        setFormErrors(errors);

        if (Object.keys(errors).length > 0) return;

        setIsSubmitting(true);
        try {
            const payload = {
                ...formData,
                appointmentDate: selectedAppointment?.date,
                idAvailability: selectedAppointment?.id,
                idDoctor: doctorId,
                idAppointmentMotive: motiveId
            };

            const response = await Appointment.createDoctorAppointment(payload);

            if (response?.data?.idAppointmentStatus) {
                // Set data in store for success page (same as patient flow)
                setStoreSelectedAppointment({
                    date: response?.data?.appointmentDate,
                    appTime: response?.data?.appointmentTime,
                    id: response?.data?.id
                });

                setDoctorData({
                    id: response?.data?.idDoctorUser,
                    fullName: docData?.fullName,
                    speciality: docData?.speciality,
                    address: docData?.address,
                    personalImage: docData?.personalImage
                });

                // Reset form
                setFormData({
                    appointmentDate: '',
                    doctorNotes: '',
                    idAppointmentMotive: '',
                    idAvailability: '',
                    idDoctor: doctorId,
                    patientEmail: '',
                    patientFirstName: '',
                    patientLastName: '',
                    patientPhone: '',
                    countryCode: '+503'
                });
                setSelectedAppointment(null);
                setIsSubmitting(false);

                // Navigate to success page with Google Calendar integration (same as patient flow)
                navigate(`/${docData?.id}/${docData?.fullName?.replace(' ', '-')}/appointment-success`, {
                    state: { appointmentId: response?.data?.id, data: response?.data }
                });
            } else {
                setApiError(response?.message || 'Error al crear la cita');
                setIsSubmitting(false);
            }
        } catch (err) {
            setTimeout(() => {
                setApiError('');
            }, 1500);
            setApiError(translateApiError(err?.response?.data?.message || err?.message || 'Error desconocido'));
            setIsSubmitting(false);
        }
    };
    const validationMessages = {
        patientFirstName: 'Nombre de pila es requerido.',
        patientLastName: 'Apellido es requerido.',
        patientEmail: 'Correo electrónico es requerido.',
        patientPhone: 'Teléfono es requerido.',
        countryCode: 'Código de país es requerido.',
        doctorNotes: 'Descripción es requerida.'
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (validationMessages[name] !== undefined) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                [name]: value.trim() === '' ? validationMessages[name] : ''
            }));
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const translateApiError = (message) => {
        const translations = {
            'NOT AUTHORISED TO MAKE APPOINTMENT': "Vous n'êtes pas autorisé à prendre un rendez-vous.",
            'INVALID EMAIL': 'Adresse e-mail invalide.',
            'APPOINTMENT SLOT NOT AVAILABLE': "Ce créneau n'est plus disponible."
            // Add more known messages here
        };
        return translations[message] || 'Une erreur est survenue. Veuillez réessayer.';
    };
    return (
        <div className={' max-w-7xl mx-auto'}>
            <div className="py-8 px-8">
                <section aria-labelledby="applicant-information-title dd" className="border-radius-24">
                    <div className="bg-white shadow sm:rounded-xl">
                        <div className="px-4 py-6 sm:px-6 border-b divide-slate-200 border-black">
                            <h2
                                id="applicant-information-title"
                                className="text-lg leading-6 font-bold text-black sm:px-6 border-red "
                            >
                                Elige motivo de consulta
                            </h2>
                        </div>
                        <div className="border-black px-4 py-5 sm:px-6 pt-0">
                            <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mt-5">
                                <div className="sm:col-span-2">
                                    <ul role="list" className="mt-5 sm:mt-0 ">
                                        {docData?.motives?.map((item, index) => (
                                            <li key={item.id}>
                                                <div role="button" className="group block">
                                                    <div
                                                        onClick={() => {
                                                            setMotiveId(item.id);
                                                            setFormErrors((prevErrors) => {
                                                                const updatedErrors = { ...prevErrors };
                                                                delete updatedErrors.idAppointmentMotive;
                                                                return updatedErrors;
                                                            });
                                                        }}
                                                        style={{
                                                            backgroundColor:
                                                                motiveId === item.id
                                                                    ? 'rgb(14 165 233 / var(--tw-bg-opacity))'
                                                                    : ''
                                                        }}
                                                        className="flex items-center py-5 px-10  bg-stone-50 mb-4 rounded-md border border-gray-200 hover:bg-stone-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                                    >
                                                        <div className="min-w-0 flex-1 flex items-center">
                                                            <div className="min-w-0 flex-1 md:grid md:grid-cols-2 md:gap-4">
                                                                <div>
                                                                    <p className="font-medium truncate text-black text-lg">
                                                                        {item.motiveName}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </dl>
                            {formErrors.idAppointmentMotive && (
                                <p className="text-red-500 text-sm mb-2 text-left">{formErrors.idAppointmentMotive}</p>
                            )}
                        </div>
                    </div>
                </section>

                <div className="border-black px-4 py-5 sm:px-6 pt-0">
                    <AppointmentCalendar
                        selectedAppointment={selectedAppointment}
                        availableAppointments={availableAppointments}
                        setSelectedAppointment={setSelectedAppointment}
                        queryAppointmentHistory={queryAppointmentHistory}
                    />
                </div>
            </div>

            <form
                onSubmit={handleFormCreate}
                className="grid grid-cols-12 gap-6 p-8 bg-white shadow sm:rounded-xl mb-4"
            >
                <div className="col-span-12 md:col-span-6">
                    <FormInputField
                        label="Nombre De Paciente"
                        identifier="patientFirstName"
                        type="text"
                        placeholder="Nombre de pila"
                        value={formData.patientFirstName}
                        onChange={handleChange}
                    />
                    {formErrors.patientFirstName && (
                        <p className="text-red-500 text-sm mt-1">{formErrors.patientFirstName}</p>
                    )}
                </div>

                <div className="col-span-12 md:col-span-6">
                    <FormInputField
                        label="Apellido del Paciente"
                        identifier="patientLastName"
                        type="text"
                        placeholder="Apellido de pila"
                        value={formData.patientLastName}
                        onChange={handleChange}
                    />
                    {formErrors.patientLastName && (
                        <p className="text-red-500 text-sm mt-1">{formErrors.patientLastName}</p>
                    )}
                </div>

                <div className="col-span-12 md:col-span-6">
                    <FormInputField
                        label="Correo Electrónico Del Paciente"
                        identifier="patientEmail"
                        type="email"
                        placeholder="Correo electrónico"
                        value={formData.patientEmail}
                        onChange={handleChange}
                        iconComponent={<MailIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                    />
                    {formErrors.patientEmail && <p className="text-red-500 text-sm mt-1">{formErrors.patientEmail}</p>}
                </div>
                <div className="col-span-12 md:col-span-6">
                    <label className="block text-sm font-medium text-dl-accent mb-2 text-black">Teléfono</label>
                    <div className="relative rounded-full w-full">
                        <PhoneInput
                            country="sv"
                            value={`${formData.countryCode}${formData.patientPhone}`}
                            onChange={(value, country) => {
                                const dialCode = `+${country.dialCode}`;
                                const phoneNumber = value.replace(country.dialCode, '').replace(/^\+/, '');

                                setFormData((prev) => ({
                                    ...prev,
                                    countryCode: dialCode,
                                    patientPhone: phoneNumber
                                }));
                                
                                // Clear errors when user starts typing
                                if (formErrors.patientPhone || formErrors.countryCode) {
                                    setFormErrors((prevErrors) => ({
                                        ...prevErrors,
                                        patientPhone: '',
                                        countryCode: ''
                                    }));
                                }
                            }}
                            countryCodeEditable={false}
                            disableAreaCodes
                            inputProps={{ required: true }}
                        />
                        {formErrors.patientPhone && (
                            <p className="text-red-500 text-sm mt-1">{formErrors.patientPhone}</p>
                        )}
                        {formErrors.countryCode && (
                            <p className="text-red-500 text-sm mt-1">{formErrors.countryCode}</p>
                        )}
                    </div>
                </div>

                <div className="col-span-12">
                    <FormTextArea
                        label="Descripción"
                        name="doctorNotes"
                        identifier="doctorNotes"
                        placeholder="Descripción"
                        value={formData.doctorNotes}
                        onChange={handleChange}
                    />
                    {formErrors.doctorNotes && <p className="text-red-500 text-sm mt-1">{formErrors.doctorNotes}</p>}
                </div>

                <div className="col-span-12 md:col-span-2 flex justify-center items-center">
                    <button
                        disabled={isSubmitting}
                        type="submit"
                        className="rounded-full disabled:opacity-75 focus:outline-none border border-transparent py-3 px-8 text-sm font-medium text-white shadow hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 bg-stone-500	 "
                    >
                        {isSubmitting ? 'Confirmando...' : 'Confirmar Cita'}
                    </button>
                </div>
            </form>

            {apiError && (
                <ErrorModal
                    title="Ha ocurrido un error"
                    bodyText={apiError}
                    mainActionText="Cerrar"
                    onMainAction={onCloseErrorModal}
                    open={apiError !== ''}
                    onClose={onCloseErrorModal}
                />
            )}
        </div>
    );
}
